import config from '../../../config';
import routes from '../../../routes.json';
import store from '../../../store';
export function setRoute(route, data) {
    if (
        config.allowedRoutes.indexOf(route) === -1 &&
        routes[route] &&
        !store.getState().user.get('authenticated')
    ) {
        data = { next: route, params: JSON.stringify(data) };
        route = 'global:login';
    }

    // console.info('create action setRoute', {
    //     type: 'ROUTES_SET_ROUTE',
    //     route,
    //     data
    // });

    return {
        type: 'ROUTES_SET_ROUTE',
        route,
        data
    };
}
